import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";
import { bfv_J9 } from "./BFV_J9";
import bflHelper from "./bflHelper";
import { IBFModule, IBFResult } from "../../types/BFL/Funktionskontroll";
import { bfv_J4 } from "./BFV_J4";
import { logAndNotifyError } from "../logger";
import { numFrmtStd } from "../common";

//todo -> make class?!
export const bfv_J3 = (): IBFModule => {
  const bfName = BFLType.BFV_J3;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    let funktionsKontroller: any[] = [];
    const debug = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    try {
      const moduleData: IModuleVattenburetSekundärsystem = module.data;

      const B7_Utstyrning_värmeventil = moduleData.varmeventilUtstyrning || (0 as number);
      const B14_VillkorUppfyllda = moduleData.pumpstoppKontroll === "PUMP I DRIFT"; //B7_Utstyrning_värmeventil > 0;   //Ändring enl mail "Ändringar i BFV J3 & BFV J4"
      const B4_ÄrVärde = (moduleData.framledningArvarde || 0) as number;
      const B6_BörVärde = (moduleData.framledningBorvarde || 0) as number;
      const B5_Diff_ÄrBör = B4_ÄrVärde - B6_BörVärde;
      //const B7_UtstyrningVärmeVentil = moduleData.varmeventilUtstyrning as number;
      const B8_ÅrligEnergiTransmission = bimHandler.BIM_ÅrligBruttoTransmission();

      const B9_ShuntensSystemAndel = moduleData.värmeSystemandel / 100;

      const bfv_j9 = bfv_J9().getResult(module, bimHandler, roundHandler, globalData);
      const B10_SchablonVärme = bfv_j9.data.schablonBesparing;

      const B11_Värmekälla = bimHandler.energiKälla;
      const B12_Vägledande_Verkningsgrad = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;

      //B13 : =OM(B5>=1,5;B5/3*((B8*B9*B10)/B12);0)
      const B13_OverKonsumtion_Brutto =
        B5_Diff_ÄrBör >= 1.5 && B12_Vägledande_Verkningsgrad !== undefined
          ? (B5_Diff_ÄrBör / 3) * ((B8_ÅrligEnergiTransmission * B9_ShuntensSystemAndel * B10_SchablonVärme) / B12_Vägledande_Verkningsgrad)
          : 0.0;

      const D8_OverKonsumtion_Netto = B13_OverKonsumtion_Brutto / B12_Vägledande_Verkningsgrad;

      //Energislag
      //E17 : =LETARAD($B$11;'Grunddata IN'!$K$44:$M$54;3;FALSKT), B11 : ='Grunddata IN'!B15
      const energiSlag = bimHandler.energiSlag;
      ///

      debug["Grundvärden BIM"] = {
        G13_ÅrligBruttoAnvändningCentralVärme: numFrmtStd.format(bimHandler.G13_ÅrligBruttoAnvändningCentralVärme()),
        G15_BIM_ÅrligBruttoTransmission: numFrmtStd.format(bimHandler.BIM_ÅrligBruttoTransmission()),
        G17_BruttoEnergiVentilation: numFrmtStd.format(bimHandler.G17_BruttoEnergiVentilation()),
        G19_BruttoEnergiVarmvatten: numFrmtStd.format(bimHandler.G19_BruttoEnergiTappvatten),
      };

      debug["Tabell 1"] = {
        B4_ÄrVärde,
        B5_Diff_ÄrBör,
        B6_BörVärde,
        B7_Utstyrning: moduleData.varmeventilUtstyrning + "%",
        B8_ÅrligEnergiTransmission,
        B9_ShuntensSystemAndel,
        B10_SchablonVärme,
        B11_Värmekälla,
        B12_Vägledande_Verkningsgrad,
        B13_OverKonsumtion_Brutto,
        B14_VillkorUppfyllda,
      };

      debug["Övrigt"] = { D8_OverKonsumtion_Netto, energiSlag };

      //Rule 4:
      // C20 : =OM(OCH(B14=1;B6-B4>=5);1;0)
      const c20_LågFramledningsTemperatur_ = B14_VillkorUppfyllda && B6_BörVärde - B4_ÄrVärde >= 5;
      if (c20_LågFramledningsTemperatur_) {
        funktionsKontroller = [
          roundHandler.getFunktionsKontroll(bfName, 4, undefined, ""),
          // {
          //   index: 4,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ3_FKText4, // "Låg framledningstemperatur orsakad av regleravvikelse. Felsök reglersignal - ställdon - ventil",
          // },
        ];
      }

      //Rule 3:
      // C19 : =OM(B14=0;1;0)
      const c19_pumpstoppAktivt = !B14_VillkorUppfyllda;
      if (c19_pumpstoppAktivt) {
        funktionsKontroller = [
          roundHandler.getFunktionsKontroll(bfName, 3, undefined, ""),
          // {
          //   index: 3,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ3_FKText3, //"Pumpstopp är aktivt. Funktionskontroll regleravvikelse utförs ej.",
          // },
        ];
      }

      //Rule 2:
      // C18 : =OM(OCH(B14=1;B13=0;B6-B4<=4,99);1;0)
      const c18_No_Remark = B14_VillkorUppfyllda && B13_OverKonsumtion_Brutto === 0 && B6_BörVärde - B4_ÄrVärde <= 4.99 ? true : false;
      if (c18_No_Remark) {
        funktionsKontroller = [
          roundHandler.getFunktionsKontroll(bfName, 2, undefined, ""),
          // {
          //   index: 2,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ3_FKText2, //"Funktionskontroll regleravvikelse utförd utan anmärkning.",
          // },
        ];
      }

      //Rule 1
      // C17 : =OM(OCH(B14=1;D17>1);1;0)        -    D17 : =OM(B14=1;B13;0)
      const showOverKonsumtion = B14_VillkorUppfyllda && B13_OverKonsumtion_Brutto ? true : false;
      if (showOverKonsumtion) {
        funktionsKontroller = [
          roundHandler.getFunktionsKontroll(bfName, 1, D8_OverKonsumtion_Netto, energiSlag),
          // {
          //   index: 1,
          //   kWhs: D8_OverKonsumtion_Netto,
          //   energiSlag: energiSlag,
          //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ3_FKText1, //"Regleravvikelse orsakar överkonsumtion värme. Felsök reglersignal - ställdon - ventil",
          // },
        ];
      }

      const bfvJ4 = bfv_J4().getResult(module, bimHandler, roundHandler, globalData);
      if (!bfvJ4.data?.ingenGemensamYta) {
        for (let i = 0; i < bfvJ4.funktionsKontroller.length; i++) {
          bfvJ4.funktionsKontroller[i].OverrideBFName = BFLType.BFV_J4;
          funktionsKontroller.push(bfvJ4.funktionsKontroller[i]);
        }
        for (let n in bfvJ4.debug) {
          debug["j4" + n] = bfvJ4.debug[n];
        }
      }

      if (bfvJ4.error) {
        error = "j4 error: " + bfvJ4.error;
      }
    } catch (ex: any) {
      logAndNotifyError(ex);
      error = ex.toString();
    }

    return {
      bfName: BFLType.BFV_J3,
      funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
      driftOptimeringar: [],
      note: "",
      error: error,
      debug,
    };
  };

  return { getResult, bfName };
};

const dflt = { bfv_J3 };

export default dflt;
